import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { AccountingGroupsService } from '@core/services/accounting-groups.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { AccountingGroup } from '@shared/interfaces/accounting-group';
import { Rule } from '@shared/interfaces/rule';

@Component({
  selector: 'app-accounting-groups-edit',
  templateUrl: './accounting-groups-edit.component.html'
})
export class AccountingGroupsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public accountingGroup: AccountingGroup;
  public accountingGroupsList: Array<AccountingGroup> = [];
  public rulesList: Array<Rule> = [];
  public accountingGroupForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private accountingGroupsService: AccountingGroupsService,
    public dialogRef: MatDialogRef<AccountingGroupsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    if (
      this.data.action === this.appConfig.ACTIONS.edit.id ||
      this.data.action === this.appConfig.ACTIONS.add.id
    ) {
      let rule: Rule;
      this.data.relationships.forEach(element => {
        rule = { id: element.id, name: element.attributes.name };
        this.rulesList.push(rule);
      });

      this.constants.title = this.appConfig.LANG.accountingGroups.title;
      this.constants.action = this.data.action;

      this.accountingGroupForm = new FormGroup({
        id: new FormControl('', Validators.required),
        name: new FormControl('', Validators.required),
        idRule: new FormControl('', Validators.required)
      });

      if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
        this.constants.title =
          this.appConfig.LANG.title.edit + ' ' + this.constants.title;
        this.accountingGroup = this.data.item;
        this.accountingGroupForm.patchValue({
          id: this.accountingGroup.id,
          name: this.accountingGroup.name,
          idRule: this.accountingGroup.idRule
        });
      } else {
        if (this.rulesList.length <= 0) {
          this.constants.admitted = false;
        } else {
          this.constants.title =
            this.appConfig.LANG.title.add + ' ' + this.constants.title;
        }
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.accountingGroupForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.accountingGroupsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
